<template>
    <div id="VehicleList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="canAccessPage === true">
              <div class="page-name">
                 <div class="page-title">Potential Cancellation Report</div>
                <!-- Button for Clear Cache -->
                <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                <a href="javascript:void(0)" class="btn btn-secondary pull-right" v-on:click="exportReports()">
                    <i class="fp-export"></i> Export
                </a>
              </div>
                <div class="container-fluid">
                    <div class="admin-page-content potential-cancellation-report">
                        <data-table-filter-config :moduleName="'potentialCancellationList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                       <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                              <custom-pagination
                                  :page-changed="onPageChange"
                                  :per-page-changed="onPerPageChange" :moduleName="'potentialCancellationList'" :position="'top'">
                              </custom-pagination>

                              <vue-good-table
                                      ref="potentialCancellationList"
                                      mode="remote"
                                      title="Asset"
                                      @on-page-change="onPageChange"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          setCurrentPage:listCurrentPage,
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"

                                      :search-options="{
                                  enabled: false,
                                  }">
                                  <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                    <div :key="key">
                                        <div v-if="props.column.field == 'reference_no'">
                                            <a class="color-blue" href="javascript:void(0)" v-on:click="selectAction(props.row.temp_booking_id ,props.row.temp_reservation_id ,flag='view')" title="View Pending Reservation">
                                            {{props.row.reference_no}}
                                            </a>
                                        </div>
                                        <div v-else>
                                            {{props.formattedRow[props.column.field]}}
                                        </div>
                                    </div>
                                </template>
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                       </div>
                    </div>
                </div>
            </template>
            <template v-else-if="canAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import EventBus from ".././event-bus";
import Vue from "vue";
import { commonMixins } from "../../mixins/commonMixins";
import {dataTableMixins} from '../../mixins/dataTableMixins';

import { locale } from 'moment';

export default {
  name: "listPendingBooking",
  mixins: [commonMixins,dataTableMixins],
  metaInfo() {
      return {
          title: "Potential Cancellation Report | " +process.env.COPYRIGHT_NAME
      }
  },
  data: () => ({
    enrichDataMsg:"",
    selResId:"",
    enrichRes: [],
    selectedRes: [],
    allSelected: false,
    resEnrichloading:false,
    firstLoad: 0,
    userRole: "",
    canAccessPage: "",
    reservQty:"",
    permissions: [],
    enrichResArr:[],
    dataNotFound:[],
    userColumns:[],
    columns: [
      {
        label: "#Reference",
        field: "reference_no",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
        width: '90px',
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "#Reference", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Customer",
        field: "company",
        fpFieldType:"text",
        filterable: true,
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Customer Name", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
        {
            label: "Asset Type",
            field: "assetType",
            fpFieldType:"option",
            filterable: true,
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Asset Type", // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                filterFn: this.onColumnFilter, //custom filter function that
                trigger: "enter" //only trigger on enter not on keyup
            }
        },

       {
           label: "Location",
           field: "location",
           filterable: true,
           fpFieldType:"option",
           hidden:false,
           filterOptions: {
               enabled: false, // enable filter for this column
               placeholder: "Filter", // placeholder for filter input
               filterValue: '', // initial populated value for this filter
               filterDropdownItems: [], // dropdown (with selected values) instead of text input
               filterFn: this.onColumnFilter, //custom filter function that
               trigger: "enter" //only trigger on enter not on keyup
           }

       },
       {
           label: "Reason",
           field: "reason",
           filterable: true,
           fpFieldType:"text",
           hidden:false,
           filterOptions: {
               enabled: false, // enable filter for this column
               placeholder: "Filter", // placeholder for filter input
               filterValue: '', // initial populated value for this filter
               filterDropdownItems: [], // dropdown (with selected values) instead of text input
               filterFn: this.onColumnFilter, //custom filter function that
               trigger: "enter" //only trigger on enter not on keyup
           }
       },
       {
           label: "Comment",
           field: "cancellation_reason",
           filterable: true,
           fpFieldType:"text",
           hidden:false,
           filterOptions: {
               enabled: false, // enable filter for this column
               placeholder: "Filter", // placeholder for filter input
               filterValue: '', // initial populated value for this filter
               filterDropdownItems: [], // dropdown (with selected values) instead of text input
               filterFn: this.onColumnFilter, //custom filter function that
               trigger: "enter" //only trigger on enter not on keyup
           }
       },

       {
        label: "Start Date",
        field: "pickup_datetime",
        filterable: true,
        fpFieldType:"date",
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "End Date",
        field: "dropoff_datetime",
        filterable: true,
        fpFieldType:"date",
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Created Date",
        field: "created_at",
        fpFieldType:"date",
        filterable: true,
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Cancelled Date",
        field: "deleted_at",
        fpFieldType:"date",
        filterable: true,
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      // {
      //   label: "Total",
      //   field: "total",
      //   fpFieldType:"integer",
      //   width: '100px',
      //   type: "number",
      //   filterable: true,
      //   hidden:false,
      //   sortable: false
      // },

    ],
    rows: [],
    totalRecords: 0,
    cancel_booking_id: 0,
    cancelvalue: "",
    loading: false,
    cantAccess: true,
    flag: "",
    flexLocation:"False",
    flexDate:"False",
    deleteRes:false,
    canMakeReservation: false,
    pageKey:"_potential_cancellation_report_list_",
    action:'list',
    batchProcess:0,
    batchNum:"",
    filterAll:[],
  }),
  watch: {
    permissions: function(permission) {
      var self = this;
      permission.forEach(function(permissions) {
        if (permissions.name == "list_potential_cancellation") {
          self.canAccessPage = true;
        }
      });
      if (self.cantAccess == "") {
        self.cantAccess = false;
      }
    }
  },
  created: function() {
      this.serverParams.sort = { field: "deleted_at", type: "desc"};
  },
  mounted: function() {
    var self = this;

    //check user loggged in or not
    var userObj = localStorage.getItem("user_obj");

    //if user logged in than remove login button and registration button
    if (userObj != null) {
      var userJson = JSON.parse(userObj);
      if (userJson.roles.length > 0) {
        this.userRole = userJson.roles[0].name;
        this.loggedinUserId = userJson.id;
      }


    }

    if (this.userRole == "customer") {
      this.$router.push("/");
    }
    this.getPermissions();
    //this.loadList();
  },
  methods: {
      cancelAll: function (cancelAll) {
              this.$refs.potentialCancellationList.unselectAllInternal();
            },
    // exportReports: function() {
    //     var self = this;
    //     this.action = "export";
    //     this.loadList();
    // },
    // // loadList is what brings back the rows from server
    loadList: function() {

      var self = this;
      self.loading = true;

      var date = new Date();
      var offset = date.getTimezoneOffset();

      self.firstLoad = 1;

      var filterAll = self.serverParams.columnFilters;
      if ( self.action == "export" ) {
          filterAll = self.removeOptionArr(self.serverParams.columnFilters);
      }
      

      $.ajax({
        url: process.env.ROOT_API + "/potential_cancelled_booking",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: filterAll,
          sort: this.serverParams.sort,
          offset: offset,
          flag: self.flag,
          action:self.action
        },
        success: function(data) {
          self.loading = false;
          // console.log(data.content);
          if (data.status == "success") {
            if (self.action == "export" ||  self.action == "export_queue") {

                  if ( data.code == "201" ) {
                      alert(data.message);
                  } else {

                      if ( self.action == "export" ) {

                          self.excel = data.content.web;
                          var save = document.createElement("a");
                          save.href = self.excel;
                          save.download = data.content.web;
                          save.target = "_blank";

                          document.body.appendChild(save);
                          save.click();
                          document.body.removeChild(save);

                      } else {

                          self.batchProcess = 1;
                          self.batchNum = data.content;
                      }

                  }

                self.action = "list";
                self.loadList();
            }else{
              if (data.content.row != undefined) {
                self.rows = data.content.row;
              }

              self.totalRecords = data.content.totalRecords;
            }
          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR,false,'potential-cancellation-list');
        }
      });
    },

    selectAction: function(temp_booking_id, temp_resevation_id, flag) {
      var self = this;
      if (flag == "view") {
        localStorage.setItem("temp_reservation_id", temp_resevation_id);
        self.$router.push({
              name: "PendingReservationContent",
              params: { id: temp_booking_id, flag: self.flag }
        });
        // self.$router.push("/viewbookings/" + id);
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/reports/PotentialCancellation.vue